
const chartjs = require('../../../../../components/chart/chartjs')
const scrim = require('../../../../../components/scrim/scrim')
const usersSnack = require('./users-snack')




export function createAllChart(detail, allCharts) {



      const dataChart = lineMultiple(detail.result.charts.usersLines)

      const systemData = [
            ...dataChart.userRequest,
            ...dataChart.sizeStorage,
            ...dataChart.sizeDb,
            ...dataChart.purchaseQty,
            ...dataChart.saleQty,
            ...dataChart.emailQty
      ]


      try {
            chartjs.start({
                  elem: 'line',
                  act: 'createMultiple',
                  targetChart: allCharts.userMultipleUser,  //html selecteed
                  data: systemData,
                  options: {
                        name: 'aspectRatio',
                        aspectRatio: 4,
                        legend: true,
                        plugins: {
                              tooltip: { enabled: true }
                        },
                  },
            })

      } catch (error) { console.log('error', error) }


}/*createAllChart*/

export function printSystemActivityReport() {

      const formData = new FormData()
      formData.append('entity', 'users')
      formData.append('reportName', 'user-system-activity')

      scrim.showLoading()

      fetch('./server/php/report/report-pdf.php', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
      })
            .then(response => {
                  const contentType = response.headers.get('Content-Type') || ''

                  if (!response.ok || !contentType.includes('application/pdf')) {
                        throw new Error('Invalid PDF response')
                  }

                  return response.blob()
            })
            .then(blob => {
                  const pdfBlob = new Blob([blob], { type: 'application/pdf' })
                  const fileUrl = URL.createObjectURL(pdfBlob)
                  const newTab = window.open(fileUrl, '_blank')

                  if (newTab) {
                        newTab.addEventListener('load', () => URL.revokeObjectURL(fileUrl), { once: true })
                  }
            })
            .catch(() => usersSnack.start({ act: 'show', id: 'reportDownloadError' }))
            .finally(() => scrim.hideLoading())

}/*printSystemActivityReport*/

///format data
function lineMultiple(data) {
      try {
            let result = {};



            let valueUserRequest = [];
            let valueSizeStorage = [];
            let valueSizeDb = [];
            let valuePurchaseQty = [];
            let valueSaleQty = [];
            let valueEmailQty = [];

            data.forEach(element => {
                  valueUserRequest.push({ x: element.month_name, y: parseFloat(element.total_request) })
                  valueSizeStorage.push({ x: element.month_name, y: parseFloat(element.total_file_size_gb) })
                  valueSizeDb.push({ x: element.month_name, y: parseFloat(element.total_db_size_gb) })
                  valuePurchaseQty.push({ x: element.month_name, y: parseFloat(element.total_purchase) })
                  valueSaleQty.push({ x: element.month_name, y: parseFloat(element.total_sale) })
                  valueEmailQty.push({ x: element.month_name, y: parseFloat(element.total_email) })
            });

            result = {
                  userRequest: [{
                        label: 'User Requests',
                        color: 'blue',
                        tension: 0.3,
                        value: valueUserRequest,
                        borderWidth: 2
                  }],
                  sizeStorage: [{
                        label: 'Storage (GB)',
                        color: 'green',
                        tension: 0.3,
                        value: valueSizeStorage,
                        borderWidth: 2
                  }],
                  sizeDb: [{
                        label: 'DataBase (GB)',
                        color: 'red',
                        tension: 0.3,
                        value: valueSizeDb,
                        borderWidth: 2
                  }],
                  purchaseQty: [{
                        label: 'Purchases',
                        color: 'orange',
                        tension: 0.3,
                        value: valuePurchaseQty,
                        borderWidth: 2
                  }],
                  saleQty: [{
                        label: 'Sales',
                        color: 'purple',
                        tension: 0.3,
                        value: valueSaleQty,
                        borderWidth: 2
                  }],
                  emailQty: [{
                        label: 'Emails Sent',
                        color: 'yellow',
                        tension: 0.3,
                        value: valueEmailQty,
                        borderWidth: 2
                  }]
            };


            return result;


      } catch (err) {
            console.log('err', err);
            return null;
      }
}/*createAllChart*/
